import { UnitWish } from "../../../../models/unit-wish-list";
import { buildingType } from "../../models/building-type.enum";
import { UnitWishExtension } from "../LivingMixSelection/LivingMixUnitCard/LivingMixUnitCard";

export enum initialPropsStepEnum {
    buildingType = 'buildingType',
    livingMix = 'livingMix',
    finished = 'finished',
}

export enum activeStateEnum {
    add = 'add',
    edit = 'edit',
    editUnitWishList = 'editUnitWishList'
}

export interface InitProperties {
    state: activeStateEnum,
    stepState: initialPropsStepEnum,
    type: buildingType,
    unitWishList: UnitWishExtension[],
    editUnitWishList?: UnitWish[],
}

export interface InitialProps {
    unitWishList: UnitWish[]
}